import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Çağlayan Koltuk Yıkama", path: "/kagithane/caglayan-koltuk-yikama" },
  { label: "Çağlayan Battaniye Yıkama", path: "/kagithane/caglayan-battaniye-yikama" },
  { label: "Gültepe Koltuk Yıkama", path: "/kagithane/gultepe-koltuk-yikama" },
  { label: "Gültepe Yorgan Yıkama", path: "/kagithane/gultepe-yorgan-yikama" },
  { label: "Yahya Kemal Mahallesi Koltuk Yıkama", path: "/kagithane/yahya-kemal-koltuk-yikama" },
  { label: "Yahya Kemal Mahallesi Perde Yıkama", path: "/kagithane/yahya-kemal-perde-yikama" },
  { label: "Seyrantepe Koltuk Yıkama", path: "/kagithane/seyrantepe-koltuk-yikama" },
  { label: "Seyrantepe Yerinde Yıkama", path: "/kagithane/seyrantepe-yerinde-yikama" },
  { label: "Ortabayır Koltuk Yıkama", path: "/kagithane/ortabayir-koltuk-yikama" },
  { label: "Ortabayır Kuru Temizleme", path: "/kagithane/ortabayir-kuru-temizleme" },
  { label: "Kağıthane Merkez Koltuk Yıkama", path: "/kagithane/merkez-koltuk-yikama" }
];

const KagithaneServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          KAĞITHANE HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default KagithaneServiceArea;
